module.exports = __webpack_public_path__ + "img/avator.6169bb40.png";